import { render } from "./oncology_list.vue?vue&type=template&id=4994f946&scoped=true"
import script from "./oncology_list.vue?vue&type=script&lang=js"
export * from "./oncology_list.vue?vue&type=script&lang=js"

import "./oncology_list.vue?vue&type=style&index=0&id=4994f946&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4994f946"]])

export default __exports__